function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3378 19.7856C18.9153 19.7856 19.3834 19.3174 19.3834 18.74C19.3834 18.1625 18.9153 17.6944 18.3378 17.6944C17.7604 17.6944 17.2922 18.1625 17.2922 18.74C17.2922 19.3174 17.7604 19.7856 18.3378 19.7856Z",
  fill: "url(#paint6_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0744 26.2198C14.6519 26.2198 15.12 25.7517 15.12 25.1742C15.12 24.5968 14.6519 24.1287 14.0744 24.1287C13.497 24.1287 13.0289 24.5968 13.0289 25.1742C13.0289 25.7517 13.497 26.2198 14.0744 26.2198Z",
  fill: "url(#paint7_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.247 23.1635C16.8244 23.1635 17.2926 22.6954 17.2926 22.1179C17.2926 21.5404 16.8244 21.0723 16.247 21.0723C15.6695 21.0723 15.2014 21.5404 15.2014 22.1179C15.2014 22.6954 15.6695 23.1635 16.247 23.1635Z",
  fill: "url(#paint8_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1802 5.06708C7.80221 5.06708 5.06763 7.80166 5.06763 11.1797C5.06763 14.5577 7.80221 17.2923 11.1802 17.2923C14.5582 17.2923 17.2928 14.5577 17.2928 11.1797C17.2928 7.80166 14.5582 5.06708 11.1802 5.06708ZM15.2017 11.1797C15.2017 13.4317 13.3518 15.2011 11.1802 15.2011C9.00865 15.2011 7.15878 13.3513 7.15878 11.1797C7.15878 9.0081 9.00865 7.15823 11.1802 7.15823C13.3518 7.15823 15.2017 8.92767 15.2017 11.1797Z",
  fill: "url(#paint9_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1796 0C4.9866 0 0 4.9866 0 11.1796C0 13.1903 0.884719 15.2815 0.965148 15.5228C1.28686 16.2466 1.84987 17.2922 2.25201 17.9357L9.65147 29.1153C10.0536 29.6783 10.6166 30 11.1796 30C11.7426 30 12.3861 29.6783 12.7078 29.1153L14.9598 25.6568L13.1903 24.5308L11.0992 27.748L3.86059 16.8097C3.53887 16.2466 2.97587 15.3619 2.73458 14.7185C2.65416 14.5576 1.9303 12.7882 1.9303 11.1796C1.9303 6.19303 6.03217 2.09115 11.0188 2.09115C16.0054 2.09115 20.1072 6.19303 20.1072 11.1796C20.1072 12.7882 19.3834 14.5576 19.3029 14.6381C19.0617 15.2011 18.5791 16.1662 18.1769 16.7292L17.1314 18.3378L18.9008 19.4638L19.9464 17.8552C20.3485 17.2118 20.9115 16.1662 21.2332 15.4424C21.2332 15.3619 22.1984 13.1903 22.1984 11.0992C22.3593 4.9866 17.3727 0 11.1796 0Z",
  fill: "url(#paint10_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 18.3378,
  y1: 17.6944,
  x2: 18.3378,
  y2: 19.7856,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 14.0744,
  y1: 24.1287,
  x2: 14.0744,
  y2: 26.2198,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 16.247,
  y1: 21.0723,
  x2: 16.247,
  y2: 23.1635,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 11.1802,
  y1: 5.06708,
  x2: 11.1802,
  y2: 17.2923,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 11.1011,
  y1: 0,
  x2: 11.1011,
  y2: 30,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})));

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.36c6ba11.svg";
export { ForwardRef as ReactComponent };